<template>
  <v-layout>
    <v-flex>
      <v-card>
        <v-card-title>
          {{ $t('tsResponderList') }}
          <v-spacer></v-spacer>
          <v-text-field id="f250cb4b" v-model="search" :label="$t('search')" append-icon="mdi-magnify" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table
          id="c5394aa6"
          must-sort
          :search="search"
          :headers="headers"
          :items="tsResponderList"
          :options.sync="pagination"
          :server-items-length="totalItems"
          :loading="loading"
          :loading-text="$t('dataTable.loadingPleaseWait')"
          :no-data-text="$t('dataTable.noDataAvailable')"
          :no-results-text="$t('dataTable.noMatchingRecordsFound')"
          :footer-props="{
            'items-per-page-text': $t('dataFooter.itemsPerPage'),
            'page-text': $t('dataFooter.pageText'),
            'items-per-page-options': [10,25,50]
          }"
        >
          <template v-slot:item.qualified="{ item }">
            <v-icon :color="item.qualified ? 'green' : 'red'">{{ item.qualified ? 'mdi-check-circle' : 'mdi-close-circle' }}</v-icon>
          </template>
          <template v-slot:item.keyStoreActivated="{ item }">
            <v-icon :color="item.keyStoreActivated ? 'green' : 'red'">{{ item.keyStoreActivated ? 'mdi-check-circle' : 'mdi-close-circle' }}</v-icon>
          </template>
          <template v-if="isAdmin" v-slot:item.action="{ item }">
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn :id="setTableItemOperationDynamicId('ec355827', item.name)" icon :to="'tsResponders/' + item.name + '/update'" v-on="on">
                  <v-icon>mdi-information-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('update') }}</span>
            </v-tooltip>
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn :id="setTableItemOperationDynamicId('1d5e406f', item.name)" icon v-on="on" @click="deleteTsResponder(item.name)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('delete') }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
      <fab-button v-if="isAdmin" id="be5acbbe" tooltip-text="add" to="tsResponders/add" />
    </v-flex>
  </v-layout>
</template>

<script>
import debounce from 'lodash.debounce'
import { mapGetters } from 'vuex'
import Role from '../../Role'
import signers from '../../api/signers'
import FabButton from '../../components/FabButton.vue'
import { showToastSuccess, showToastError, showConfirmationDialog } from '../../event-bus'

export default {
  name: 'TsResponderList',

  components: {
    'fab-button': FabButton
  },

  data() {
    return {
      search: null,
      pagination: {
        sortBy: ['name']
      },
      tsResponderList: [],
      totalItems: 0,
      loading: false,
      headers: [
        {
          text: this.$t('name'),
          align: 'left',
          value: 'name'
        },
        {
          text: this.$t('qualified'),
          value: 'qualified',
          sortable: false
        },
        {
          text: this.$t('keyStoreName'),
          value: 'keyStoreName',
          sortable: false
        },
        {
          text: this.$t('keyStoreActivated'),
          value: 'keyStoreActivated',
          sortable: false
        },
        {
          text: this.$t('actions'),
          value: 'action',
          sortable: false
        }
      ]
    }
  },

  computed: {
    ...mapGetters(['hasRole']),
    isAdmin() {
      return this.hasRole(Role.ADMIN)
    }
  },

  watch: {
    search() {
      this.loading = true
      this.searchTsResponderWatcher()
    },

    pagination() {
      this.searchTsResponders()
    }
  },

  methods: {
    async searchTsResponders() {
      this.loading = true
      try {
        let pageRequest = {
          'page-num': this.pagination.page,
          'page-size': this.pagination.itemsPerPage,
          'sort-field': this.pagination.sortBy[0],
          'sort-order': this.pagination.sortDesc[0] ? 'desc' : 'asc'
        }
        let page = await signers.listTsResponders(this.search, pageRequest)
        this.tsResponderList = page.content
        this.totalItems = page.total
      } catch (error) {
        showToastError(this.$t('toastMessage.errorWhileRetrievingData'))
      } finally {
        this.loading = false
      }
    },

    searchTsResponderWatcher: debounce(function() {
      this.searchTsResponders()
    }, 500),

    async deleteTsResponder(name) {
      let conf = await showConfirmationDialog(this.$t('confirmation'), this.$t('dialog.text.deleteItem'), true, this.$t('dialog.text.deleteItemKey'))
      if (!conf.confirmedValue) {
        return
      }

      try {
        await signers.deleteTsResponder(name, conf.confirmedCheckboxValue)
        this.searchTsResponders()
        showToastSuccess(this.$t('toastMessage.succesfullyDeleted'))
      } catch (error) {
        let errorMsg = this.$t('toastMessage.errorWhileRetrievingData')
        if (error.response != null) {
          switch (error.response.data.code) {
            case 'STILL_REFERENCED':
              errorMsg = this.$t('toastMessage.stillReferenced', { param: 'TsResponder', param2: 'keyAlias' })
              break
            case 'GENERAL':
              errorMsg = '(' + error.response.data.code + ')' + ' ' + error.response.data.message
          }
        }
        showToastError(errorMsg)
      }
    }
  }
}
</script>
